"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendBulkSmsMasking = exports.smsBalanceCheckMasking = exports.sendBulkSmsNonMask = exports.smsBalanceCheck = exports.validatePhoneNumber = exports.checkStatusOfSMS = exports.sendSms = void 0;
var axios_1 = __importDefault(require("axios"));
var smsUrl = 'https://portal.adnsms.com/api/v1/secure/send-sms';
var checkBalanceSmsUrl = 'https://portal.adnsms.com/api/v1/secure/check-balance';
var checkSmsStatusUrl = 'https://portal.adnsms.com/api/v1/secure/sms-status';
var maskApiKey = 'KEY-k38guy6njrkoaucqc5nabure1x6hg95n';
var maskApiSecretKey = 'T1MaO7uiAXKijsT5';
var nonMaskApiKey = 'KEY-tyv2hlpyt1acha7b1mfes5ni0kk0s90u';
var nonMaskApiSecretKey = 't@jsTRam5kbaeb!2';
function sleepSMS(ms) {
    return new Promise(function (resolve) { return setTimeout(resolve, ms); });
}
var chunkSmsArr = function (arr, len) {
    if (len === void 0) { len = 308; }
    var inputArr = checkElLength(arr, len);
    var outputArr = [], msgString = '', count = 0;
    for (var i = 0; i < inputArr.length; i++) {
        if ((msgString + inputArr[i]).length <= len) {
            msgString += inputArr[i];
        }
        else {
            msgString = '';
            msgString += inputArr[i];
            count++;
        }
        outputArr[count] = msgString;
    }
    return outputArr;
};
var checkElLength = function (inputArr, len) {
    var outputArr = [];
    for (var i = 0; i < inputArr.length; i++) {
        if (inputArr[i].length > len) {
            var breakedSmsArr = breakSmsArrString(inputArr[i], len);
            inputArr.splice.apply(inputArr, __spreadArray([i, 1], breakedSmsArr, false));
        }
    }
    outputArr = inputArr;
    return outputArr;
};
var getSmsNum = function (i, length) {
    return "[".concat(i + 1, "/").concat(length, "]");
};
var breakSmsArrString = function (str, len) {
    var curr = len, prev = 0;
    var output = [];
    while (str[curr]) {
        if (str[curr++] == ' ') {
            output.push(str.substring(prev, curr));
            prev = curr;
            curr += len;
        }
        else {
            var currReverse = curr;
            do {
                if (str.substring(currReverse - 1, currReverse) == ' ') {
                    output.push(str.substring(prev, currReverse));
                    prev = currReverse;
                    curr = currReverse + len;
                    break;
                }
                currReverse--;
            } while (currReverse > prev);
        }
    }
    output.push(str.substr(prev));
    return output;
};
var sendSms = function (phoneNumber, smsArr, apiKey, secretKey, masking) { return __awaiter(void 0, void 0, void 0, function () {
    var ak, sk, formData, arr, sms_uid, i, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                ak = apiKey && masking === true ? apiKey : maskApiKey;
                sk = secretKey && masking === true ? secretKey : maskApiSecretKey;
                formData = new FormData();
                formData.append('api_key', ak);
                formData.append('api_secret', sk);
                formData.append('request_type', 'SINGLE_SMS');
                formData.append('message_type', 'TEXT');
                formData.append('isPromotional', '0');
                formData.append('campaign_title', 'Doctor Koi Regular SMS');
                formData.append('mobile', "".concat(phoneNumber));
                arr = chunkSmsArr(smsArr);
                sms_uid = [];
                i = 0;
                _a.label = 1;
            case 1:
                if (!(i < arr.length)) return [3, 7];
                formData.append('message_body', arr.length > 1 ? getSmsNum(i, arr.length) + '\n' + arr[i] : arr[i]);
                _a.label = 2;
            case 2:
                _a.trys.push([2, 5, , 6]);
                return [4, axios_1.default
                        .post(smsUrl, formData, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    })
                        .then(function (res) {
                        sms_uid.push(res.data.sms_uid);
                    })];
            case 3:
                _a.sent();
                return [4, sleepSMS(2000)];
            case 4:
                _a.sent();
                return [3, 6];
            case 5:
                err_1 = _a.sent();
                throw err_1.response.data.error;
            case 6:
                i++;
                return [3, 1];
            case 7: return [2, sms_uid];
        }
    });
}); };
exports.sendSms = sendSms;
var checkStatusOfSMS = function (uuid, apiKey, secretKey) { return __awaiter(void 0, void 0, void 0, function () {
    var formData, ak, sk, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                formData = new FormData();
                ak = apiKey ? apiKey : maskApiKey;
                sk = secretKey ? secretKey : maskApiSecretKey;
                formData.append('api_key', ak);
                formData.append('api_secret', sk);
                formData.append('sms_uid', uuid);
                return [4, axios_1.default.post(checkSmsStatusUrl, formData, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    })];
            case 1:
                response = _a.sent();
                return [2, response.data];
        }
    });
}); };
exports.checkStatusOfSMS = checkStatusOfSMS;
var validatePhoneNumber = function (number) {
    var bool = false;
    var reg = /\+?^(88)?01[3456789][0-9]{8}\b/;
    if (reg.test("".concat(number))) {
        bool = true;
    }
    else
        bool = false;
    return bool;
};
exports.validatePhoneNumber = validatePhoneNumber;
var smsBalanceCheck = function () { return __awaiter(void 0, void 0, void 0, function () {
    var formData, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                formData = new FormData();
                formData.append('api_key', nonMaskApiKey);
                formData.append('api_secret', nonMaskApiSecretKey);
                return [4, axios_1.default.post(checkBalanceSmsUrl, formData, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    })];
            case 1:
                response = _a.sent();
                return [2, response.data];
        }
    });
}); };
exports.smsBalanceCheck = smsBalanceCheck;
var sendBulkSmsNonMask = function (phoneNumber, smsText, withMasking) { return __awaiter(void 0, void 0, void 0, function () {
    var ak, sk, options, res, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 6, , 7]);
                ak = withMasking ? maskApiKey : nonMaskApiKey;
                sk = withMasking ? maskApiSecretKey : nonMaskApiSecretKey;
                options = {
                    api_key: ak,
                    api_secret: sk,
                    request_type: 'GENERAL_CAMPAIGN',
                    message_body: smsText,
                    message_type: 'TEXT',
                    mobile: phoneNumber.join(','),
                    isPromotional: 0,
                    campaign_title: 'Doctor Koi',
                };
                return [4, axios_1.default.post(smsUrl, options)];
            case 1:
                res = _a.sent();
                if (!(res.status === 200)) return [3, 3];
                return [4, sleepSMS(2000)];
            case 2:
                _a.sent();
                return [2, res.data];
            case 3: return [4, sleepSMS(2000)];
            case 4:
                _a.sent();
                throw new Error("Some thing went wrong while sending sms : ".concat(JSON.stringify(res.data)));
            case 5: return [3, 7];
            case 6:
                err_2 = _a.sent();
                throw err_2.response;
            case 7: return [2];
        }
    });
}); };
exports.sendBulkSmsNonMask = sendBulkSmsNonMask;
var smsBalanceCheckMasking = function (apiKey, secretKey) { return __awaiter(void 0, void 0, void 0, function () {
    var formData, ak, sk, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                formData = new FormData();
                ak = apiKey ? apiKey : maskApiKey;
                sk = secretKey ? secretKey : maskApiSecretKey;
                formData.append('api_key', ak);
                formData.append('api_secret', sk);
                return [4, axios_1.default.post(checkBalanceSmsUrl, formData, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    })];
            case 1:
                response = _a.sent();
                return [2, response.data];
        }
    });
}); };
exports.smsBalanceCheckMasking = smsBalanceCheckMasking;
var sendBulkSmsMasking = function (phoneNumber, smsText, apiKey, secretKey, masking) { return __awaiter(void 0, void 0, void 0, function () {
    var ak, sk, options, res, err_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 6, , 7]);
                ak = apiKey && masking === true ? apiKey : nonMaskApiKey;
                sk = secretKey && masking === true ? secretKey : nonMaskApiSecretKey;
                options = {
                    api_key: ak,
                    api_secret: sk,
                    request_type: 'GENERAL_CAMPAIGN',
                    message_body: smsText,
                    message_type: 'TEXT',
                    mobile: phoneNumber.join(','),
                    isPromotional: 0,
                    campaign_title: 'Doctor Koi Masking TEXT Service',
                };
                return [4, axios_1.default.post(smsUrl, options)];
            case 1:
                res = _a.sent();
                if (!(res.status === 200)) return [3, 3];
                return [4, sleepSMS(2000)];
            case 2:
                _a.sent();
                return [2, res.data];
            case 3: return [4, sleepSMS(2000)];
            case 4:
                _a.sent();
                throw new Error("Some thing went wrong while sending sms : ".concat(JSON.stringify(res.data)));
            case 5: return [3, 7];
            case 6:
                err_3 = _a.sent();
                throw err_3.response;
            case 7: return [2];
        }
    });
}); };
exports.sendBulkSmsMasking = sendBulkSmsMasking;
//# sourceMappingURL=SMS.js.map